import { TextEditor, TextEditorProps } from '@components/text-editors';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormTextEditorProps<T = unknown> = FormFieldProps<TextEditorProps, T>;

export function FormTextEditor<T>(props: FormTextEditorProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'text-editor' });

  return <TextEditor {...props} {...formFieldProps} />;
}
